import React from "react";
import styled from "styled-components";

const SubscribeSection = styled.section`
  background-color: #183b7c;
  color: #ffffff;
  padding-top: 40px;
  padding-bottom: 40px;
  text-align: center;
`;

const H3 = styled.h3`
  color: rgb(255, 255, 255);
  display: block;
  font-family: europa;
  font-size: 30px;
  font-weight: 400;
  line-height: 63.6px;
  white-space: pre-wrap;
  margin: 0 0 20px 0;
`;

const Para = styled.p`
  margin: 0 0 20px 0;
  color: rgb(255, 255, 255);
  display: block;
  font-family: europa;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
`;

const Subscribe = () => {
  return (
    <SubscribeSection>
      <H3>Subscribe</H3>
      <Para>Sign up with your email address to receive updates</Para>
    </SubscribeSection>
  );
};

export default Subscribe;
